<template>
    <div class="ChildrenPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('AddChild')" v-bind:class="{ active: PanesShown == 'AddChild' }"><font-awesome-icon :icon="['fa', 'plus']" /> Add Child</b-nav-item>
                            <b-nav-item v-on:click="ChangePaneShown('Children')" v-bind:class="{ active: PanesShown == 'Children' }"><font-awesome-icon :icon="['fa', 'list']" /> Children</b-nav-item>
                            <b-nav-item v-for="(childRecord, childSPMID) in OpenChildRecords" v-if="childRecord.hasOwnProperty('Client')" v-bind:class="{ active: PanesShown == childSPMID }">
                                <span v-on:click="ChangePaneShown(childSPMID)">
                                    <font-awesome-icon :icon="['fa', 'child']" />
                                    {{ childRecord.Client.Person.FirstNameLastInitial }}
                                </span>
                                <span style="float:right" v-on:click="CloseChildRecord(childSPMID)">X</span>
                            </b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-show="PanesShown == 'AddChild'">
                                <AddNewChild />
                            </div>
                            <div v-show="PanesShown == 'Children'">
                                <ChildList />
                            </div>
                            <div v-for="(childRecord, childSPMID) in OpenChildRecords" v-if="childRecord.hasOwnProperty('Client')" v-show="PanesShown == childSPMID">
                                <ChildRecord v-bind:child-record-data="childRecord" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ChildList from "./ChildList.vue";
    import AddNewChild from "./AddNewChild.vue";
    import ChildRecord from "./ChildRecord/ChildRecord.vue";

    export default {
        props: [],
        data: function () {
            return {
                PanesShown: "Children"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            },
            CloseChildRecord: function (spmID) {
                if (this.PanesShown == spmID) {
                    this.ChangePaneShown("Children");
                }
                this.$store.commit("Clients.ClientProfiles.Remove", spmID);
                
            },
        },
        computed: {
            OpenChildRecords() {
                return this.$store.state.Clients.ClientProfiles;
            }
        },
        components: {
            ChildList,
            AddNewChild,
            ChildRecord
        }
        //mounted() {
        //    this.getUsers();
        //    console.log("ran get users method");
        //}
    }
</script>

<style scoped>

</style>